export enum UserRoleEnum {
    ROLE_ZILIUS_ADMIN = 'ROLE_ZILIUS_ADMIN',
    ROLE_CARE_OPERATOR = 'ROLE_CARE_OPERATOR',
    ROLE_PHYSICIAN = 'ROLE_PHYSICIAN',
    ROLE_ORGANIZATION_QUALITY_OFFICER = 'ROLE_ORGANIZATION_QUALITY_OFFICER',
}
